'use strict';

var _ = require('lodash');
var MappedRulesController = function MappedRulesController($scope, MappedRulesService, userSecureService, $filter, $state, strategyConstants, transitionSearchCriteriaService, $interpolate) {
  var linkReadOnlyView = $interpolate('<a href="#" data-uid="{{uid}}" class="readOnlyRule">{{linkText}}</a>');
  $scope.rulesPermission = false;
  var rmMomentFormat = $filter('rmMomentFormat');
  var headerFormat = _.replace($scope.headerFormat, /date\((\w+)\)/, function (m, propName) {
    return rmMomentFormat($scope.entityData[propName], 'DATE_USER_SETTINGS');
  });
  if (!$scope.entityData) {
    $scope.entityData = {};
  }
  $scope.checkPermissions = function () {
    $scope.rulesPermission = userSecureService.hasAuthorization('rules');
  };
  function updateGrid(data) {
    $scope.rulesGridSettings.source = _.sortBy(data.detailedRules, 'name');
  }
  $scope.gridHeaderCaption = _.template(headerFormat)($scope.entityData);
  $scope.gridId = 'rules-drawer-grid';
  $scope.rulesGridSettings = {
    width: '100%',
    height: '100%',
    altrows: true,
    selectionmode: 'checkbox_multiplerowsadvanced',
    columns: [{
      text: 'Rule Name',
      dataField: 'name',
      cellsalign: 'center',
      align: 'center',
      cellsrenderer: function cellsrenderer(row, columnfield, value, defaultHtml) {
        var currentRow = $scope.rulesGridSettings.source[row];
        var data = {
          uid: currentRow.technicalId,
          linkText: value
        };
        return defaultHtml.replace('>' + value + '<', '>' + linkReadOnlyView(data) + '<');
      }
    }]
  };
  function getRuleTechnicalId(rule) {
    return rule.technicalId;
  }
  function getRuleCreatedBy(rule) {
    return rule.createdBy;
  }
  function getSelectedRules() {
    var selectedRowIndexes = $scope.rulesGridSettings.jqxGrid('selectedrowindexes') || [];
    return _.filter($scope.rulesGridSettings.source, function (el, ix) {
      return selectedRowIndexes.length === 0 || selectedRowIndexes.indexOf(ix) > -1;
    });
  }
  function getSelectedRulesIds() {
    return _.chain(getSelectedRules()).map(getRuleTechnicalId).uniq().value();
  }
  function getRulesUserIds() {
    return _.chain(getSelectedRules()).map(getRuleCreatedBy).uniq().value();
  }
  $scope.navigateToRules = function () {
    var selectedRulesIds = getSelectedRulesIds();
    var transitionData = {
      panel: strategyConstants.PANEL_TYPE.OPTIMIZATION
    };
    if (!$scope.rulesGridSettings.source || $scope.rulesGridSettings.source.length === 0) {
      transitionData.skipSearch = true;
    } else {
      var userIds = getRulesUserIds();
      transitionData.searchCriteria = transitionSearchCriteriaService.drawerToRules(userIds);
      transitionData.rulesIds = selectedRulesIds;
    }
    $state.go('app.rules', {
      transitionData: transitionData
    });
  };
  MappedRulesService.getAppliedRules($scope.entityData.appliedRules).then(updateGrid);
  $scope.checkPermissions();
};
MappedRulesController.$inject = ['$scope', 'MappedRulesService', 'UserSecureService', '$filter', '$state', 'StrategyConstants', 'TransitionSearchCriteriaService', '$interpolate'];
module.exports = MappedRulesController;